import React from "react";
import PropTypes from "prop-types";
import * as dayjs from "dayjs";
import loadable from "@loadable/component";

import { AppContext } from "../../../context";
import { BRANDS, MODES } from "../../../configs";

const BrandDateRangePicker = loadable(() => import("../../Shared/DatesField/BrandDateRangePicker"));
const SovBrandDateRangePicker = loadable(() =>
	import("../../Shared/DatesField/SovBrandDateRangePicker")
);

const DatesField = ({
	id,
	mode,
	className,
	type,

	error,
	isWidgetReset,
	isOnlyDateField,
	openCalendar,

	classnames,

	selectedDates,
	availableDates,
	previousDates,

	ParentRefElement,

	onChange,
	setOpenRoomAndGuest,
	setShowPassengerPopover,
	setIsInitialSovMobileInputState,
	handleSovMobileInputSelectionToView,
}) => {
	const [useAppState] = AppContext.useAppContext();

	if (useAppState.brand.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		return (
			<SovBrandDateRangePicker
				id={id}
				mode={mode}
				type={type}
				className={className}
				classnames={classnames}
				selectedDates={selectedDates}
				availableDates={availableDates}
				previousDates={previousDates}
				isWidgetReset={isWidgetReset}
				openMobileCalendar={openCalendar}
				error={error}
				setOpenRoomAndGuest={setOpenRoomAndGuest}
				onChange={(startDate, returnDate) => {
					onChange([dayjs(startDate), dayjs(returnDate)]);
				}}
				isOnlyDateField={isOnlyDateField}
				ParentRefElement={ParentRefElement}
				setShowPassengerPopover={setShowPassengerPopover}
				setIsInitialSovMobileInputState={setIsInitialSovMobileInputState}
				handleSovMobileInputSelectionToView={handleSovMobileInputSelectionToView}
			/>
		);
	}

	return (
		<BrandDateRangePicker
			className={className}
			id={id}
			selectedDates={selectedDates}
			availableDates={availableDates}
			previousDates={previousDates}
			error={error}
			onChange={(startDate, returnDate) => {
				onChange([dayjs(startDate), dayjs(returnDate)]);
			}}
		/>
	);
};

DatesField.propTypes = {
	id: PropTypes.string.isRequired,
	mode: PropTypes.string,
	className: PropTypes.string,
	type: PropTypes.oneOf(["range", "date"]),

	error: PropTypes.bool,
	isWidgetReset: PropTypes.bool,
	isOnlyDateField: PropTypes.bool,
	openCalendar: PropTypes.bool,

	classnames: PropTypes.shape({
		listboxTail: PropTypes.string,
	}),

	selectedDates: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.instanceOf(dayjs),
		PropTypes.string,
	]),
	availableDates: PropTypes.shape({
		RolloverAvailableDays: PropTypes.number,
		RolloverMaxAvailableDays: PropTypes.number,
		DefaultAvailableDate: PropTypes.string,
		DefaultMaxAvailableDate: PropTypes.string,
	}),
	previousDates: PropTypes.arrayOf(PropTypes.string),

	ParentRefElement:  PropTypes.shape({ current: PropTypes.object }),

	onChange: PropTypes.func.isRequired,
	setOpenRoomAndGuest: PropTypes.func,
	setShowPassengerPopover: PropTypes.func,
	setIsInitialSovMobileInputState: PropTypes.func,
	handleSovMobileInputSelectionToView: PropTypes.func,
};

DatesField.defaultProps = {
	mode: MODES.SEARCH,
	className: undefined,
	type: undefined,

	error: false,
	isWidgetReset: false,
	isOnlyDateField: false,
	openCalendar: false,

	classnames: undefined,

	selectedDates: undefined,
	previousDates: undefined,
	availableDates: undefined,
	
	ParentRefElement: null,

	setOpenRoomAndGuest: () => {},
	setShowPassengerPopover: () => {},
	setIsInitialSovMobileInputState: () => {},
	handleSovMobileInputSelectionToView: () => {},
};

// eslint-disable-next-line import/prefer-default-export
export { DatesField };
